// price: $23.99, priceValue -> 23.99, priceDollars -> 23, priceCents -> 99
export const getPriceValue = (price: string = '') =>
  price.includes('$') ? price.split('$')[1] : price;

export const getPriceDollars = (price: string = '') => {
  const priceValue = getPriceValue(price);
  return price.includes('.') ? priceValue.split('.')[0] : priceValue;
};

export const getPriceCents = (price: string = '') => {
  const priceValue = getPriceValue(price);
  return price.includes('.') ? priceValue.split('.')[1] : '';
};
